<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：会员-添加
      -->
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      size="small"
      :model="form"
      :rules="rules"
      ref="form"
      v-loading="formLoading"
    >
      <!-- 固定格式 -->
      <el-form-item
        label="接口类型"
        :label-width="formLabelWidth"
        prop="remark.plugin_name"
      >
        <el-select
          v-model="form.remark.plugin_name"
          :disabled="!!model"
          @change="handleTypeChange"
        >
          <el-option
            v-for="item in options"
            :value="item.path"
            :label="item.name"
            :key="item.api_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="接口状态"
        :label-width="formLabelWidth"
        prop="status"
      >
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启动</el-radio>
          <el-radio :label="2">禁用</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item
        label="接口方式"
        :label-width="formLabelWidth"
        prop="mode"
      >
        <el-radio-group v-model="form.mode">
          <el-radio :label="0">本站接口</el-radio>
          <el-radio :label="1">外站接口</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="接口类型"
        :label-width="formLabelWidth"
        prop="type"
      >
        <el-radio-group v-model="form.api_type">
          <el-radio :label="0">开放接口</el-radio>
          <el-radio :label="1">请求接口</el-radio>
        </el-radio-group>
        <div>说明：开放接口，用于给到外部请求，请求接口，用于记录外部的开发接口</div>
      </el-form-item>

      <!-- 动态渲染 -->
      <template v-if="formItems">

        <el-form-item label="排序" :label-width="formLabelWidth" prop="sort">
       <div style="display: flex;">
        <el-input
          type="number"
          v-model="form.sort"
          autocomplete="off"
        style="flex: 8.4;"></el-input>

        <div style="flex: 1.6;"></div> 
       </div>
      </el-form-item>

        <el-form-item
          v-for="item in formItems"
          :label="item.text"
          :label-width="formLabelWidth"
          :key="item.name"
          :prop="'remark.' + item.name"
        >
          <template v-if="item.type === 'input'">
            <div style="display: flex;">
              <el-input  v-if="item.name!='api_secret'"
              v-model="form.remark[item.name]"
              autocomplete="off"
              :placeholder="model ? '' : item.placeholder"
             style="flex: 1;"></el-input>
             <el-input v-if="item.name=='api_secret'"
              v-model="form.remark[item.name]"
              autocomplete="off"
              :placeholder="model ? '' : item.placeholder"
             style="flex: 9;"></el-input>
             <div style="flex: 0.2;"></div>
             <el-button type="primary" style="flex: 1;"  v-if="item.name == 'api_secret'">生成密钥</el-button>
            </div>
            
          </template>
          <template v-if="item.type === 'radio'">
            <el-radio-group v-model="form.remark[item.name]">
              <el-radio
                v-for="option in item.option"
                :key="option.value"
                :label="option.value"
                >{{ option.label }}</el-radio
              >
            </el-radio-group>
          </template>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitApi" :loading="loading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import Api from "@/api/api.js";
import { deepClone } from "@/utils/base.js";

export default {
  data() {
    return {
      form: {
        remark: { plugin_name: "" },
        status: 1,
        sort: 50,
        mode:0,//0 本站接口  1  外部接口
      },
      rules: {
        "remark.plugin_name": [
          { required: true, message: "请选择接口标准", trigger: "blur" }
        ],
        status: [
          { required: true, message: "请选择接口状态", trigger: "blur" }
        ],
        mode: [
          { required: true, message: "请选择接口方式", trigger: "blur" }
        ],
        api_type: [
          { required: true, message: "请选择接口类型", trigger: "blur" }
        ],
        sort: [{ required: true, message: "请输入接口排序", trigger: "blur" }]
      },
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /* 类型 */
      typeList: [],
      /* 表单Items */
      formItems: null,
      formLoading: false
    };
  },
  props: ["open_edit", "model", "options"],
  computed: {
    title() {
      return this.model ? "编辑接口" : "添加接口";
    }
  },
  created() {
    this.init();
  },
  methods: {
    /* 初始化数据 */
    async init() {
      this.dialogVisible = this.open_edit;
      if (this.model) {
        this.form = deepClone(this.model);
        await this.handleTypeChange(this.model.remark.plugin_name);
      }
      // this.form = this.model ? deepClone(this.model) : this.form;
    },

    /* 处理选择接口类型后的操作 */
    async handleTypeChange(value) {
      this.formLoading = true;
      this.formItems = await this.getFormItems(value);
      this.rules = this.getFormRules(this.formItems, this.rules);
      this.formLoading = false;
    },

    /* 获取表单规则 */
    getFormRules(options = [], rules) {
      const newRules = options.reduce((acc, cur) => {
        if (cur.rules) {
          const name = "remark." + cur.name;
          acc = { ...acc, [name]: cur.rules };
        }
        return acc;
      }, {});
      return { ...rules, ...newRules };
    },

    /* 获取表单子项 */
    async getFormItems(value) {
      try {
        const res = await Api.getApiPlugin({ plugin_name: value });
        return res.data;
      } catch (error) {}
    },

    // 提交api表单
    submitApi() {
      this.$refs.form.validate(valid => {
        if (valid) {
          /* 祖传API请求参数代码，不要动这个格式化 */
          const formatForm = {
            ...this.form,
            ...this.form.remark
          };
          /* 祖传结束 */
          if (this.model) {
            this.updateApi(formatForm);
          } else {
            this.addApi(formatForm);
          }
        } else {
          return false;
        }
      });
    },

    /* 添加API */
    async addApi(form) {
      try {
        this.loading = true;
        await Api.addApi(form);
        this.$emit("closeDialog", true);
      } catch (error) {
        this.loading = false;
      }
    },

    /* 修改API */
    async updateApi(form) {
      try {
        this.loading = true;
        await Api.editApi(form);
        this.$emit("closeDialog", true);
      } catch (error) {
        this.loading = false;
      }
    },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/api/app/part/Edit.vue